import React, { useEffect, useRef } from 'react'

import { Divider, Modal } from 'antd'
import RichTextEditor from '../base/RichTextEditor'
import { convertToHTML } from 'draft-convert'

const BioEditForm = ({ toLoad, visible, onSubmit, onCancel }) => {
  //destructures props
  const inputRef = useRef()

  useEffect(() => {
    if (toLoad && inputRef.current && visible) {
      inputRef.current.loadCurr()
    }
  }, [toLoad, visible])

  return (
    <Modal
      visible={visible}
      title='Edit Bio'
      okText='OK'
      onCancel={onCancel}
      width={'66vw'}
      style={{ top: 20 }}
      onOk={() => {
        const editor = inputRef.current?.state.editorState
        if (editor && editor.getCurrentContent().hasText()) {
          const html = convertToHTML(editor.getCurrentContent())
          if (onSubmit) onSubmit(html)
        }
      }}
    >
      <div
        style={{
          width: '100%',
          height: '66vh',
          paddingTop: 6,
          paddingBottom: 6,
          paddingRight: 24,
          overflowY: 'auto',
          overflowX: 'hidden'
        }}
      >
        <p>
          <i>
            Write a short introduction about yourself.{' '}
            <a style={{ color: 'black', textDecoration: 'underline' }} href={'https://revart.co/sam/faq/docs/doc-showcase/'}>
              Learn More
            </a>
            .
          </i>
        </p>
        <Divider />
        <h5>Bio:</h5>
        <RichTextEditor ref={inputRef} toLoad={toLoad} style={{ minHeight: 260 }} />
      </div>
    </Modal>
  )
}

export default BioEditForm
